import { Flex } from 'antd';
import { useSelector } from 'react-redux';
import FormBlock from '../../../../../Components/UI/FormBlock/FormBlock';
import FormBlockSubtitle from '../../../../../Components/UI/FormBlock/FormBlockSubtitle/FormBlockSubtitle';
import FormBlockTitle from '../../../../../Components/UI/FormBlock/FormBlockTitle/FormBlockTitle';

const OpenAccess = (props) => {
    const { jsonbody = {}, more = false } = props
    return (
        <Flex vertical>
            {!!jsonbody.user ? <FormBlock title="Данные нового пользователя">
                <FormBlockSubtitle>{jsonbody?.user.fullname}</FormBlockSubtitle>
                <FormBlockSubtitle>{jsonbody?.user.phone}</FormBlockSubtitle>
                <FormBlockSubtitle>{jsonbody?.user.job.title}</FormBlockSubtitle>
                <FormBlockSubtitle>{jsonbody?.user.job?.dateEmployment}</FormBlockSubtitle>
            </FormBlock> : null}
            {more ? (<>
                {
                    (jsonbody.email && (jsonbody.email?.value || jsonbody.email?.task)) ?
                        <FormBlock title="Учетная запись ПОЧТЫ">
                            {jsonbody.email.value ? <FormBlockSubtitle>{jsonbody.email?.value}</FormBlockSubtitle> : null}
                            {jsonbody.email.groups ? <FormBlockSubtitle>{jsonbody.email?.groups}</FormBlockSubtitle> : null}
                            { }
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.access.server?.createAccount || jsonbody.access.server?.remoteAccess || (jsonbody.access?.server?.folders.length > 0)) ?
                        <FormBlock title="Доступ к серверу">
                            {
                                jsonbody.access.server.createAccount ?
                                    <div className='block__checked'>
                                        <div className='checkbox'><div className='checkbox_active'></div></div>
                                        <FormBlockSubtitle>Создать учетную запись на сервере </FormBlockSubtitle>
                                    </div>

                                    : null
                            }
                            {
                                jsonbody.access.server.remoteAccess ?
                                    <div className='block__checked'>
                                        <div className='checkbox'><div className='checkbox_active'></div></div>
                                        <FormBlockSubtitle>Нужен внешний доступ к серверу</FormBlockSubtitle>
                                    </div>
                                    : null
                            }

                            {
                                (jsonbody.access.server.folders && jsonbody.access.server.folders[0]?.name) ?
                                    <FormBlockTitle>Доступ к общим папкам</FormBlockTitle>
                                    : null
                            }

                            {
                                (jsonbody.access.server.folders && jsonbody.access.server.folders[0]?.name) ?
                                    jsonbody.access.server.folders.map((folder, index) => {
                                        return (
                                            <div className='flex_row' key={folder.access + index}>
                                                <FormBlockSubtitle>{folder.name}</FormBlockSubtitle>
                                                <FormBlockSubtitle>{folder.access}</FormBlockSubtitle>
                                            </div>
                                        )
                                    }) : null
                            }
                        </FormBlock> : null
                }
                {
                    (jsonbody.access.buh_1c.iconColor || jsonbody.access.buh_1c.path) ?
                        <FormBlock title="Доступ к 1С">
                            {
                                jsonbody.access.buh_1c.iconColor === "yellow" ?
                                    <FormBlockSubtitle>Желтый значок</FormBlockSubtitle> :
                                    jsonbody.access.buh_1c.iconColor === "blue" ?
                                        <FormBlockSubtitle>Синий значок</FormBlockSubtitle> :
                                        null
                            }
                            {
                                jsonbody.access.buh_1c.path ? <FormBlockSubtitle>{jsonbody.access.buh_1c.path}</FormBlockSubtitle>
                                    : null
                            }
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.access.corpPhone.access || jsonbody.access.corpPhone.needDevice) ?
                        <FormBlock>
                            {
                                jsonbody.access.corpPhone.access ? <FormBlockTitle>Создать внутренний номер</FormBlockTitle>
                                    : null
                            }
                            {
                                jsonbody.access.corpPhone.number ? <FormBlockSubtitle>{jsonbody.access.corpPhone.number}</FormBlockSubtitle>
                                    : null
                            }
                            {
                                jsonbody.access.corpPhone.needDevice ? <FormBlockSubtitle>Установить новый телефонный аппарат</FormBlockSubtitle>
                                    : null
                            }
                        </FormBlock>
                        : null
                }
                {
                    jsonbody.revokeLicenses ?
                        <FormBlock title="Отозвать лицензии">
                            <FormBlockSubtitle>{jsonbody.revokeLicenses}</FormBlockSubtitle>
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.software.msoffice.version || jsonbody.software.msoffice.apps.length > 0 || jsonbody.software.msoffice.another) ?
                        <FormBlock title="Установить ПО">
                            {
                                jsonbody.software.msoffice.version ? <FormBlockSubtitle>{jsonbody.software.msoffice.version}</FormBlockSubtitle>
                                    : null
                            }
                            {
                                jsonbody.software.msoffice.apps ?
                                    jsonbody.software.msoffice.apps.map(app => (
                                        <FormBlockSubtitle key={app}>{app}</FormBlockSubtitle>
                                    ))
                                    : null
                            }
                            {
                                jsonbody.software.msoffice.another ? <FormBlockSubtitle>{jsonbody.software.msoffice.another}</FormBlockSubtitle>
                                    : null
                            }
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.software.antivirus.fromList.length > 0 || jsonbody.software.antivirus.otherName) ?
                        <FormBlock title="Антивирус">
                            {
                                jsonbody.software.antivirus.fromList !== "Другое" ?
                                    <FormBlockSubtitle>{jsonbody.software.antivirus.fromList}</FormBlockSubtitle> :
                                    jsonbody.software.antivirus.fromList === "Другое" ?
                                        <FormBlockSubtitle>{jsonbody.software.antivirus.otherName}</FormBlockSubtitle>
                                        : null
                            }
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.software.goverment.fromList.length > 0 || jsonbody.software.goverment.otherName) ?
                        <FormBlock title="Налоговое ПО">
                            {
                                jsonbody.software.goverment.fromList.map(goverment => {
                                    if (goverment === "Другой портал") {
                                        return null
                                    } else {
                                        return <FormBlockSubtitle key={goverment}>{goverment}</FormBlockSubtitle>
                                    }
                                }
                                )
                            }
                            {
                                jsonbody.software.goverment.otherName ? <FormBlockSubtitle>{jsonbody.software.goverment.otherName}</FormBlockSubtitle> : null
                            }
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.software.bank) ?
                        <FormBlock title="Банковские программы">
                            <FormBlockSubtitle>{jsonbody.software.bank}</FormBlockSubtitle>
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.software.utilites.fromList.length > 0 || jsonbody.software.utilites.otherName) ?
                        <FormBlock title="Дополнительное ПО">
                            {
                                jsonbody.software.utilites.fromList ?
                                    jsonbody.software.utilites.fromList.map(utilite => (
                                        <FormBlockSubtitle key={utilite}>{utilite}</FormBlockSubtitle>
                                    )) : null
                            }
                            {jsonbody.software.utilites.otherName ? <FormBlockSubtitle>{jsonbody.software.utilites.otherName}</FormBlockSubtitle> : null}
                        </FormBlock>
                        : null
                }
                {
                    jsonbody.comment ?
                        // <div className='comment_wrapper'>
                        //     <FormBlockTitle>Дополнительный комментарий</FormBlockTitle>
                        //     <p className='commentResponse'>
                        //         {jsonbody.comment}
                        //     </p>
                        // </div>
                        <FormBlock title="Дополнительный комментарий">
                            <p>{jsonbody.comment}</p>
                        </FormBlock>
                        : null

                }
            </>) : null}
        </Flex>
    ); // Placeholder for OpenAccess component
}

const ChangeAccess = (props) => {
    const { jsonbody = {}, more = false } = props
    return (
        <Flex vertical>
            {jsonbody.user ? <FormBlock title="Данные пользователя">
                <FormBlockSubtitle>{jsonbody?.user.fullname}</FormBlockSubtitle>
                <FormBlockSubtitle>{jsonbody?.user.phone}</FormBlockSubtitle>
            </FormBlock> : null}
            {more ? (<>
                {
                    jsonbody.device ?
                        <FormBlock title="Данные оборудования">
                            {jsonbody.device.oldId ? <FormBlockSubtitle>Старое оборудование: {jsonbody.device.oldId}</FormBlockSubtitle> : null}
                            {
                                jsonbody.device.used ? <FormBlockSubtitle>Новым оборудованием будет оборудование: {jsonbody.device.newId}</FormBlockSubtitle> : <FormBlockSubtitle>Новому оборудование нужен новый id</FormBlockSubtitle>
                            }
                        </FormBlock> : null
                }
                {
                    jsonbody.needMove ?
                        <FormBlock title="Нужно перенести">
                            {
                                jsonbody.needMove
                            }
                        </FormBlock> : null
                }
                {
                    jsonbody.comment ?
                        <FormBlock title="Дополнительный комментарий">
                            <p>{jsonbody.comment}</p>
                        </FormBlock>
                        : null

                }
            </>) : null}
        </Flex>
    ); // Placeholder for ChangeAccess component
}

const CloseAccess = (props) => {
    const { jsonbody = {}, more = false } = props
    return (
        <Flex vertical>
            {jsonbody.user ? <FormBlock title="Данные пользователя">
                <FormBlockSubtitle>{jsonbody?.user.fullname}</FormBlockSubtitle>
            </FormBlock> : null}
            {more ? (<>
                {
                    (jsonbody.device && jsonbody.device.id) ?
                        <FormBlock title="Данные оборудования">
                            <FormBlockSubtitle>{jsonbody.device.id}</FormBlockSubtitle>
                        </FormBlock> : null
                }
                {
                    (jsonbody.email && (jsonbody.email?.value || jsonbody.email?.task)) ?
                        <FormBlock title="Учетная запись ПОЧТЫ *">
                            {jsonbody.email.value ? <FormBlockSubtitle>{jsonbody.email?.value}</FormBlockSubtitle> : null}
                            {jsonbody.email.task ? <FormBlockSubtitle>Нужно: {jsonbody.email?.task}</FormBlockSubtitle> : null}
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.access.server && (jsonbody.access.server.blockAccount || jsonbody.access.server.blockRemoteAccess)) ?
                        <FormBlock title="Учетная запись ПОЧТЫ *">
                            {
                                jsonbody.access.server.blockAccount ?
                                    <div className='block__checked'>
                                        <div className='checkbox'><div className='checkbox_active'></div></div>
                                        <FormBlockSubtitle>Заблокировать учетную запись на сервере </FormBlockSubtitle>
                                    </div>

                                    : null
                            }
                            {
                                jsonbody.access.server.blockRemoteAccess ?
                                    <div className='block__checked'>
                                        <div className='checkbox'><div className='checkbox_active'></div></div>
                                        <FormBlockSubtitle>Заблокировать внешний доступ к серверу</FormBlockSubtitle>
                                    </div>

                                    : null
                            }
                        </FormBlock>
                        : null
                }
                {
                    (jsonbody.access.corpPhone && (jsonbody.access.corpPhone.block || jsonbody.access.corpPhone.number)) ?
                        <FormBlock title="Доступ к телефонии">
                            {
                                jsonbody.access.corpPhone.block ? <FormBlockSubtitle>Заблокировать
                                    {jsonbody.access.corpPhone.number ?
                                        <span> телефон {jsonbody.access.corpPhone.number}</span>
                                        : null}

                                </FormBlockSubtitle>
                                    : null
                            }
                        </FormBlock>
                        : null
                }
                {
                    jsonbody.revokeLicences ? <FormBlock title="Отозвать лицензии">{jsonbody.revokeLicences}</FormBlock> : null
                }


                {
                    jsonbody.comment ?
                        <FormBlock title="Дополнительный комментарий">
                            <p>{jsonbody.comment}</p>
                        </FormBlock>
                        : null

                }
            </>) : null}

        </Flex>
    ); // Placeholder for CloseAccess component
}

const tryParseJson = (jsonString) => {
    try {
        return JSON.parse(jsonString);
    } catch (e) {
        console.error("Invalid JSON string:", jsonString, e);
        return null;
    }
}


export const TaskDetailsJsonBody = (props) => {
    const { more = false } = props;
    const task = useSelector(state => state.applications.currentApplicationData);
    const body = task?.jsonBody || '{}';
    const jsonbody = tryParseJson(body);

    // return (
    //     <div style={{ width: '100%' }}>
    //         <pre style={{ width: '100%', overflow: 'hidden' }}>{JSON.stringify(jsonbody, null, 4)}</pre>
    //     </div>
    // );

    if (!jsonbody) {
        return null; // Return null if JSON parsing fails
    }

    if (jsonbody.applicationType === "openAccess") {
        return <OpenAccess more={more} jsonbody={jsonbody} />;
    }
    if (jsonbody.applicationType === "changeAccess") {
        return <ChangeAccess more={more} jsonbody={jsonbody} />;
    }
    if (jsonbody.applicationType === "closeAccess") {
        return <CloseAccess more={more} jsonbody={jsonbody} />;;
    }
    return null;
}